<nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-dark mb-3 fixed-right">
  <div class="container-fluid" style="max-width: 1200px">
    <a class="navbar-brand" [routerLink]="brandLink" [title]="displayBrandName">
      <span class="spaced-letters">{{ displayBrandName.slice(0, displayBrandName.length - 1) }}</span>{{ displayBrandName.slice(displayBrandName.length - 1) }}
    </a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarSupportedContent" [attr.aria-label]="'label.navigera' | translate">
      <span class="navbar-toggler-icon navbar-toggler-icon-alt"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav ms-auto">
        @if (isNorgeMode) {
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/no/soknad" [attr.title]="'norge.navbar.sok-lonnsgaranti' | translate" (click)="isCollapsed = true">
              <fa-icon [icon]="['fas', 'pen-nib']" [fixedWidth]="true" class="me-2"></fa-icon>
              <span class="navbar-label">{{ 'norge.navbar.sok-lonnsgaranti' | translate }}</span>
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/no/les-mer" [attr.title]="'norge.navbar.les-mer' | translate" (click)="isCollapsed = true">
              <fa-icon [icon]="['fas', 'info']" [fixedWidth]="true" class="me-2"></fa-icon>
              <span class="navbar-label">{{ 'norge.navbar.les-mer' | translate }}</span>
            </a>
          </li>
        } @else {
          @if (!isLoggedIn) {
            <li class="nav-item" routerLinkActive="active">
              @if (!isBorgenarMode) {
                <a class="nav-link" routerLink="/login" [attr.title]="'navbar.logga-in' | translate" (click)="isCollapsed = true">
                  <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="me-2"></fa-icon>
                  <span class="navbar-label">{{ 'navbar.logga-in' | translate }}</span>
                </a>
              }
              @if (isBorgenarMode) {
                <a class="nav-link" routerLink="/borgenar" [attr.title]="'navbar.logga-in' | translate" (click)="isCollapsed = true">
                  <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="me-2"></fa-icon>
                  <span class="navbar-label">{{ 'navbar.logga-in' | translate }}</span>
                </a>
              }
            </li>
          }
          @if (isLoggedIn && isBorgenarMode && !isOnGroupAcceptPage) {
            <li class="nav-item" [class.active]="isMinaFordringarActive">
              <a class="nav-link" routerLink="/borgenar" [attr.title]="'navbar.mina-bevakningsarenden' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'gavel']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.mina-bevakningsarenden' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && showPubliceradeFiler) {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['/borgenar/arende', selectedCaseId, 'publicerade-filer']" [attr.title]="'navbar.publicerade-filer' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'folder-open']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.publicerade-filer' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && (role === 'adv' || role === 'hl')) {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" routerLink="/mina-arenden" [attr.title]="'navbar.mina-arenden' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'gavel']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.mina-arenden' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && role === 'adv') {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" routerLink="/mina-tradar" [attr.title]="'navbar.mina-meddelanden' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'marker']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.mina-meddelanden' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && role === 'arb') {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" routerLink="/beslut" [attr.title]="'navbar.mina-beslut' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'gavel']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.mina-beslut' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn
            && (((role !== 'arb') && selectedCaseId)
            || role === 'arb')
            && (this.router.url.startsWith('/beslut')
            || this.router.url.startsWith('/ovrig-info')
            || this.router.url.startsWith('/anstallning')
            || this.router.url.startsWith('/mina-arenden/')
            || this.router.url.startsWith('/settings')
            || this.router.url.startsWith('/huvud-b2'))) {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" routerLink="/ovrig-info" [attr.title]="'navbar.ovrig-info' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'info']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.ovrig-info' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && role === 'arb') {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" routerLink="/settings" [attr.title]="'navbar.mina-uppgifter' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'user']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.mina-uppgifter' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn && showChangeLogin) {
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['/select-instance']" [queryParams]="{ enforce: true }" [attr.title]="'navbar.byt-inloggning' | translate" (click)="isCollapsed = true">
                <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.byt-inloggning' | translate }}</span>
              </a>
            </li>
          }
          @if (hasRequests && isLoggedIn && !isCreditorMode) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/mina-meddelanden" [attr.title]="'navbar.mina-meddelanden' | translate" (click)="isCollapsed = true">
                <span class="fa-layers fa-fw">
                  <fa-icon [icon]="['fas', 'envelope']" [fixedWidth]="true" class="me-2"></fa-icon>
                  @if (waitingRequestsCount > 0) {
                    <span class="fa-layers-counter">{{ waitingRequestsCount }}</span>
                  }
                </span>
                <span class="ms-2 d-xl-none d-lg-none">{{ 'navbar.mina-meddelanden' | translate }}</span>
              </a>
            </li>
          }
          @if (isLoggedIn) {
            <li class="nav-item">
              <a class="nav-link" href="#" queryParamsHandling="preserve" [attr.title]="'navbar.logga-ut' | translate" (click)="$event.preventDefault(); isCollapsed = true; logout()">
                <fa-icon [icon]="['fas', 'sign-out-alt']" [fixedWidth]="true" class="me-2"></fa-icon>
                <span class="navbar-label">{{ 'navbar.logga-ut' | translate }}</span>
              </a>
            </li>
          }
        }
        <li class="nav-item">
          <a class="nav-link" href="#" queryParamsHandling="preserve" [attr.title]="'navbar.byt-sprak' | translate" (click)="$event.preventDefault(); isCollapsed = true; switchLanguage()">
            <span class="flag-icon flag-icon-squared rounded" [ngClass]="'flag-icon-' + language.flag"></span><span class="ms-2 d-xl-none">{{ 'navbar.byt-sprak' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
